import React from 'react';
import {onSocketChange} from "../../slices/optionChainSlice";
import store from "../../store";
import {BasketModelToggle} from "../../slices/basketOrderSlice";
import {OptionStrategyToggle} from "../../slices/optionStrategySlice";
import {toggleAlertsListModel} from "../../slices/alertSlices";

export function HandleSocket(value:any) {
    store.dispatch(onSocketChange(value))
}

export function HandleBasketModel(value:any) {
    store.dispatch(BasketModelToggle(value))
}

export function optionStrategyModel(value:any){
    store.dispatch(OptionStrategyToggle(value))
}

export function alertsListModel(value:any){
    store.dispatch(toggleAlertsListModel(value))
}

